import { NotFoundError } from "@/domain/errors";
import { ApiQuery, ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { FinancialResponse, PayoutResponse } from "../../dtos/responses";
import { FinancialDataSource } from "./FinancialDataSource";

export class FinancialRemoteDataSource implements FinancialDataSource {
  constructor(private readonly api: ApiService) {}

  async getFinancial(query: ApiQuery) {
    const { data } = await this.api.get<FinancialResponse>(
      Endpoints.payouts,
      query,
    );

    if (!data) {
      throw new NotFoundError("Informações financeiras");
    }

    return data;
  }

  async getPayoutById(id: number): Promise<PayoutResponse> {
    const { data } = await this.api.get<PayoutResponse>(
      `${Endpoints.payouts}/${id}`,
    );

    if (!data) {
      throw new NotFoundError("Repasse");
    }

    return data;
  }
}
